export const CocurricularActions ={
    GET_COCURRICULAR :"GET_COCURRICULAR",
    SET_COCURRICULAR:"SET_COCURRICULAR"
}